import { PermissionEnum } from '../enums/permission-enum';

export class ListView<T> {
  Object_List: T[];
  Total: number;
  Permissions: PermissionEnum[];
  getTotalPages: number;
  getTotalElements: number;
  currentPage: number;
  pageSize: number;
  isEmpty: boolean;
  isFirst: boolean;
  isLast: boolean;
  isSorted: boolean;

  constructor(
    Object_List: T[] = [],
    Total: number = 0,
    Permissions: PermissionEnum[] = [],
    getTotalPages: number = 0,
    getTotalElements: number = 0,
    currentPage: number = 0,
    pageSize: number = 100,
    isEmpty: boolean = false,
    isFirst: boolean = false,
    isLast: boolean = false,
    isSorted: boolean = false
  ) {
    this.Object_List = Object_List;
    this.Total = Total;
    this.Permissions = Permissions;
    this.getTotalPages = getTotalPages;
    this.getTotalElements = getTotalElements;
    this.currentPage = currentPage;
    this.pageSize = pageSize;
    this.isEmpty = isEmpty;
    this.isFirst = isFirst;
    this.isLast = isLast;
    this.isSorted = isSorted;
  }
}
